import { mapGetters, mapActions, mapMutations } from 'vuex';

//---helpers
import { globalLoader, MEDIA } from '@/helpers/variables';

//---mixins
import { dynamicHead } from '@/mixins/dynamic-head.js';

//---components
import Pagination from '@/components/@general/Pagination/index.vue';
import BreadcrumbsSimple from '@/components/@general/BreadcrumbsSimple/index.vue';
import InputMultiselect from '@/components/custom/InputMultiselect/index.vue';
import ReviewClientCard from '@/components/cards/ReviewClientCard/index.vue';
import ReviewsPagination from '@/modules/Reviews/ReviewsPagination/index.vue';
import ReviewProfessionalCard from '@/components/cards/ReviewProfessionalCard/index.vue';
import { debounce } from 'lodash';

export default {
  name: 'reviews',
  mixins: [dynamicHead],
  components: {
    ReviewProfessionalCard,
    ReviewsPagination,
    ReviewClientCard,
    InputMultiselect,
    BreadcrumbsSimple,
    Pagination
  },
  data() {
    return {
      MEDIA,
      reviewsData: null,
      isLoadingReviewsClients: false,
      reviewsClients: [],
      reviewsClientsMeta: {
        page: 1,
        per_page: 8
      },
      isLoadReviewsProfessionals: false,
      reviewsProfessionals: [],
      reviewsProfessionalsMeta: {
        page: 1,
        per_page: 6
      },

      currentFilters: {},
      currentSearch: ''
    };
  },

  async created() {
    globalLoader(true);
    await this._loadContent();
  },
  watch: {},
  computed: {
    ...mapGetters({
      filters: 'filters/filters'
    }),
    reviewFilters() {
      return this.filters.filter((f) => f.slug !== 'aksesuari');
    }
  },
  methods: {
    ...mapMutations({
      modalOpen: 'app/MODAL_OPEN'
    }),
    ...mapActions({
      getClientsReviews: 'reviews/GET_CLIENTS_REVIEWS',
      getProfessionalsReviews: 'reviews/GET_PROFESSIONALS_REVIEWS',
      getPage: 'staticPages/GET_PAGE',
      getFilters: 'filters/GET_FILTERS'
    }),

    async _loadContent() {
      let promiseCollection = [];
      if (!this.filters.length) {
        promiseCollection.push(this.getFilters());
      }
      promiseCollection.push(this._getClientsReviews());
      promiseCollection.push(this._getProfessionalsReviews());
      promiseCollection.push(
        this.getPage('feedbacks').then((data) => {
          this.reviewsData = data;
          this._setMetaParams();
        })
      );

      await Promise.all(promiseCollection).then();
      globalLoader(false);
    },

    _setMetaParams() {
      let { title, metaTitle, metaDescription, image } = this.reviewsData;
      this.metaParams.title = `${metaTitle || title} ${this.$t('seo.metaTitleGeneral')}`;
      this.metaParams.description = metaDescription || `${metaTitle || title} ${this.$t('seo.metaDescGeneral')}`;
      this.metaParams.image = image || null;
      this.setMeta();
    },

    async _getClientsReviews() {
      let categories_id = Object.values(this.currentFilters)
        .flat()
        .map((f) => f.id)
        .join(',');

      let filters = categories_id ? { categories_id } : {};
      let { page, per_page } = this.reviewsClientsMeta;

      if (this.currentSearch) {
        filters.search = this.currentSearch;
      }

      this.isLoadingReviewsClients = true;
      return this.getClientsReviews({ page, per_page, ...filters }).then((result) => {
        this.reviewsClients = result.data;
        this.reviewsClientsMeta.lastPage = result.meta.lastPage;
        this.isLoadingReviewsClients = false;
      });
    },

    async _getProfessionalsReviews() {
      let { per_page, page } = this.reviewsProfessionalsMeta;
      this.isLoadReviewsProfessionals = true;
      return this.getProfessionalsReviews({ per_page, page }).then((result) => {
        this.reviewsProfessionals = result.data;
        this.reviewsProfessionalsMeta.lastPage = result.meta.lastPage;
        this.isLoadReviewsProfessionals = false;
      });
    },

    onSelectFilter(filter, slug) {
      if (filter?.length) {
        this.currentFilters[slug] = filter;
      } else {
        delete this.currentFilters[slug];
      }

      this._getClientsReviews();
    },

    onChangeFilter: debounce(function (event) {
      this._getClientsReviews();
    }, 700),

    onResetFilters() {
      this.currentFilters = {};
      this.currentSearch = '';
      this._getClientsReviews();
    },

    onGetClientsReviewsPage(page) {
      this.reviewsClientsMeta.page = page;
      this._getClientsReviews();
    },
    onGetProfessionalReviewsPage(page) {
      this.reviewsProfessionalsMeta.page = page;
      this._getProfessionalsReviews();
    },
    onShowReviewCreateModal() {
      this.modalOpen('reviewCreateModal');
    }
  }
};
